import React, { createContext, useContext, useState, useEffect } from 'react';

const GuestContext = createContext({});

const GUEST_SESSION_KEY = 'blueprint_guest_session_id';
const GUEST_NAME_KEY = 'blueprint_guest_name';

// Simple unique ID generator (no external dependencies)
const generateUniqueId = () => {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
};

export const GuestProvider = ({ children }) => {
  const [guestSessionId, setGuestSessionId] = useState(null);
  const [guestName, setGuestName] = useState(null);
  const [isGuest, setIsGuest] = useState(false);

  // Initialize guest session from localStorage
  useEffect(() => {
    let sessionId = localStorage.getItem(GUEST_SESSION_KEY);
    if (!sessionId) {
      sessionId = generateUniqueId();
      localStorage.setItem(GUEST_SESSION_KEY, sessionId);
    }
    setGuestSessionId(sessionId);

    const storedName = localStorage.getItem(GUEST_NAME_KEY);
    if (storedName) {
      setGuestName(storedName);
    }
  }, []);

  const setGuestInfo = (name) => {
    setGuestName(name);
    localStorage.setItem(GUEST_NAME_KEY, name);
    setIsGuest(true);
  };

  const clearGuestInfo = () => {
    setGuestName(null);
    setIsGuest(false);
    localStorage.removeItem(GUEST_NAME_KEY);
    // Keep session ID for tracking purposes
  };

  const value = {
    guestSessionId,
    guestName,
    isGuest,
    setGuestInfo,
    clearGuestInfo,
  };

  return <GuestContext.Provider value={value}>{children}</GuestContext.Provider>;
};

export const useGuest = () => useContext(GuestContext);




